import { createSlice } from '@reduxjs/toolkit'
import {getFactoryOfficesByCityId, getFactoryOfficesByProvinceId, getFactoryOfficeSchedules} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  officesByProvince: {
    elements: [],
    loading: "idle",
    error: null
  },
  officesByCity:{
    elements:[],
    loading: "idle",
    error: null
  }
 }

const factoryOfficesSlice = createSlice({
  name: 'factoryOffices',
  initialState,
  reducers: {
      clearFactoryOfficeSchedules: (state) => {
        state.officeSchedules.element = {};
      }
  },
  extraReducers: {
    [getFactoryOfficesByProvinceId.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryOfficesByProvinceId.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.officesByProvince.elements = action.payload
      
    },
    [getFactoryOfficesByProvinceId.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
      [getFactoryOfficesByCityId.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryOfficesByCityId.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.officesByCity.elements = action.payload
      
    },
    [getFactoryOfficesByCityId.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const { clearFactoryOfficeSchedules } = factoryOfficesSlice.actions;
export default factoryOfficesSlice.reducer
